import { PermissionsType } from '@/common/permissionsConst';
import MapStation from '.';
import { Themes } from '@maxtropy/components';

const routes = [
  {
    path: '/bsaStation/asset/GISdashBoard',
    permission: PermissionsType.P_ENERGYGISSUMMARY,
    element: <MapStation />,
    theme: Themes.DARK,
  },
];
export default routes;
